import React from 'react';
import { TextField } from '@mui/material';

const MultilineTextField = (props) => {
  const { minRows = 3, maxRows = 10, ...otherProps } = props;

  return (
    <TextField
      multiline
      minRows={minRows}
      maxRows={maxRows}
      {...otherProps}
    />
  );
};

export default MultilineTextField;
